<template><!-- 포틀릿 과정목록 뷰 공통 -->
  <div>
    <span v-if="corsList && corsList.length > 0">
      <table>
        <tr v-for="(item, idx) in corsList" :key="idx + '_' + item.corsCd">
          <td style="width:200px">
            <span style="color: #09c;cursor:pointer" @click="openDetail(item)">
              <img
                :src="item.thumbLinkUrl" style="width:160px;height:100px"
                alt=""
                class="thumImg">
            </span>
          </td>
          <td>
            상품속성유형 : {{ item.prdtAttrTypNm }}({{ item.prdtAttrTyp }})<br>
            난이도 : {{ item.diflvTypNm }}({{ item.diflvTyp }}) /  교재제공 : {{ item.txtbkYn }}<br>
            평가점수 : {{ item.evalAvg }} / 평가인원 : {{ item.evalCnt }}<br>
            교육일 : {{ item.eduDtm }} /  금액 : {{ item.ucstSmtotAmt }}<br>
            상품명 : <span v-html="item.prdtNm"/><br>
            키워드 : {{ item.srchKwrdCntnt }}
          </td>
        </tr>
      </table>
    </span>
  </div>
</template>
<script>

import commonMixin from '@/mixin/commonMixin'
import globalMixin from '@/mixin/globalMixin'

export default {
  name: 'SubCorsList',
  components: {

  },
  mixins: [commonMixin, globalMixin],
  metaInfo () {

  },
  props: {
    corsList: {
      type: Array,
      default: null
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  created () {

  },
  mounted () {
    console.log('corsList', this.corsList)
  },
  methods: {
    // 과정 상세
    openDetail (item) {
      console.log('item', item)

      this.$goPage({name: 'CrsDetail', query: { corsCd: item.corsCd }})
    }

  }
}
</script>

<style scoped>
ol.colorlist {
  list-style: none !important;
  counter-reset: li !important;
}

.colorlist li::before {
  content: counter(li)!important;
  color: red !important;
  display: inline-block!important;
  width: 1em !important;
  margin-left: -1em !important;
}

.colorlist li {
  counter-increment: li !important;
}

b {
    background-color: #fff !important;
    color: #00adfb !important;
    font-weight: 500 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/nrw/common/SubCorsList.vue